module.exports = __webpack_public_path__ + "img/become_content_provider_bg.753f0223.png";